import React from 'react';
export function SolutionSection() {
  return <section className="w-full bg-black py-16 px-4" data-id="element-329">
      <div className="max-w-4xl mx-auto text-center" data-id="element-330">
        {/* Badge */}
        <div className="inline-flex items-center gap-2 border border-[#B87AFF]/50 text-[#B87AFF] font-bold text-sm px-5 py-2 rounded-full mb-8 tracking-wide" data-id="element-331">
          🏆 Sistema N°1 para Profesores de Yoga en Argentina
        </div>

        <h2 className="text-4xl sm:text-5xl font-black text-white mb-4" data-id="element-332">
          🧘 PROFEPACK™
        </h2>
        <h3 className="text-2xl sm:text-3xl font-bold text-[#B87AFF] mb-6" data-id="element-333">
          MEGAPACK YOGA LISTO
        </h3>
        <p className="text-white text-lg max-w-2xl mx-auto mb-10 leading-relaxed" data-id="element-334">
          <strong data-id="element-335">
            6 Tomos + 6 Bonos — Todos los niveles — Todo resuelto.
          </strong>
          <br data-id="element-336" />
          +400 páginas · 120+ secuencias de clase · 60 guiones de meditación ·
          Técnica · Pranayama · Filosofía · Talleres · Terapéutico · Negocio.
          Funciona desde hoy.
        </p>

        {/* Mockup visual */}
        <div className="relative mx-auto mb-10 max-w-2xl" data-id="element-337">
          <div className="grid grid-cols-6 gap-2 justify-center" data-id="element-338">
            {['#1565C0', '#2E7D32', '#E65100', '#6A1B9A', '#37474F', '#BF360C'].map((color, i) => {
            const labels = ['Nivel Inicial', 'Intermedio I', 'Intermedio II', 'Avanzado', 'Especiales', 'La Mente'];
            return <div key={i} className="aspect-[3/4] rounded-lg shadow-2xl flex items-end justify-center pb-2" style={{
              backgroundColor: color,
              border: '2px solid #B87AFF'
            }} data-id="element-339">
                  <span className="text-white text-xs font-bold text-center px-1" style={{
                textShadow: '0 1px 3px rgba(0,0,0,0.8)'
              }} data-id="element-340">
                    {labels[i]}
                  </span>
                </div>;
          })}
          </div>
          <div className="absolute -bottom-3 left-1/2 -translate-x-1/2 bg-[#B87AFF] text-black font-black text-xs px-4 py-1 rounded-full whitespace-nowrap" data-id="element-341">
            6 TOMOS COMPLETOS
          </div>
        </div>

        {/* Pills */}
        <div className="flex flex-wrap items-center justify-center gap-3 mt-8" data-id="element-342">
          <span className="bg-[#B87AFF]/10 border border-[#B87AFF]/40 text-[#B87AFF] text-sm font-semibold px-4 py-2 rounded-full" data-id="element-343">
            ✅ Por nivel y edad
          </span>
          <span className="bg-[#B87AFF]/10 border border-[#B87AFF]/40 text-[#B87AFF] text-sm font-semibold px-4 py-2 rounded-full" data-id="element-344">
            ✅ 120+ secuencias de clase listas
          </span>
          <span className="bg-[#B87AFF]/10 border border-[#B87AFF]/40 text-[#B87AFF] text-sm font-semibold px-4 py-2 rounded-full" data-id="element-345">
            ✅ Evaluación + rúbricas por nivel
          </span>
          <span className="bg-[#B87AFF]/10 border border-[#B87AFF]/40 text-[#B87AFF] text-sm font-semibold px-4 py-2 rounded-full" data-id="element-346">
            ✅ Pranayama + Meditación + Filosofía
          </span>
        </div>
      </div>
    </section>;
}